<template>
  <div class="col col-lg-3 mb-4">
    <div class="input-group">
      <label>
        Codigo Agente CCEE
        <span v-if="migracaoSimplificada" class="required-markup">*</span>
        <input
          class="form-control mt-2"
          maxlength="18"
          @input="validar"
          @blur="repararString"
          :class="{
            'is-invalid': $v.model.content.$error,
            'recent-updated': migracaoSimplificada && recentUpdatedField,
          }"
          :disabled="!migracaoSimplificada || disabled"
          v-model.trim="$v.model.content.$model"
        />
      </label>
    </div>
  </div>
</template>

<script>
import { minLength } from "vuelidate/lib/validators";
import TooltipInformacaoAlterada from "@/components/forms/TooltipInformacaoAlterada.vue";
import FieldTemplateUpperCase from "@/components/forms/fields/empresa/FieldTemplateUpperCase.vue";
import { requiredIf } from "vuelidate/lib/validators";

export default {
  extends: FieldTemplateUpperCase,
  props: {
    disabled: Boolean,
    modelProp: Object,
    recentUpdatedField: Boolean,
    migracaoSimplificada: Boolean,
  },
  data() {
    return {
      model: {
        name: "codigoAgenteCCEE",
        content: "",
      },
    };
  },
  methods: {
    validar() {
      const text = this.model.content;
      const regex = /^[0-9]+$/;
      if (!regex.test(text)) {
        this.model.content = text.replace(/\D/g, "");
      }
    },
    isInvalid() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.mxToggleErrorMessageAlert("Código de Agente CCEE inválido");
        return true;
      }
      return false;
    },
  },
  validations: {
    model: {
      content: {
        required: requiredIf(function () {
          return this.migracaoSimplificada;
        }),
        minLength: minLength(1),
      },
    },
  },
  watch: {
    migracaoSimplificada: {
      handler() {
        if (!this.migracaoSimplificada) {
          this.model.content = "";
        }
      },
      immediate: true,
    },
  },
  computed: {
    IS_REQUIRED() {
      if (this.migracaoSimplificada) {
        return true;
      }
    },
  },
  components: {
    TooltipInformacaoAlterada,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/style.scss";

label {
  width: 100% !important;
}
</style>
